<template>
    <div class="metrics-banner">
      <div v-for="metric in metricsArray" class="metrics-banner__metric">
        <svg-icon class="metrics-banner__icon" :icon="metric.icon"></svg-icon>
        <span v-if="loading" class="metrics-banner__loading">&hellip;</span>
        <span v-else>{{ metric.text }}</span>
      </div>
    </div>
</template>

<script>

import SvgIcon from '@/components/common/svgIcon'
import childrenIcon from '@/assets/svg/children.svg'
import marriageIcon from '@/assets/svg/marriage.svg'
import homeIcon from '@/assets/svg/home.svg'
import maleIcon from '@/assets/svg/male.svg'
import femaleIcon from '@/assets/svg/female.svg'
import dollarSignIcon from '@/assets/svg/dollar-sign.svg'
import truncateAmount from '@/filters/truncateAmount'

const iconArray = [
  {icon: maleIcon, key: 'male'},
  {icon: femaleIcon, key: 'female'},
  {icon: childrenIcon, key: 'kids'},
  {icon: homeIcon, key: 'house'},
  {icon: marriageIcon, key: 'marriage'},
  {icon: dollarSignIcon, key: 'income', truncateAmount: true}
]

function percentageString (num) {
  return num.toFixed(1) + '%'
}

export default {
  components: {
    SvgIcon
  },
  props: {
    metrics: {
      type: Object | null,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    metricsArray () {
      if (!this.metrics) return []
      return iconArray.reduce((arr, obj) => {
        if (this.metrics.hasOwnProperty(obj.key)) {
          const text = obj.truncateAmount ? truncateAmount(this.metrics[obj.key]) : percentageString(this.metrics[obj.key])
          const newMetric = {icon: obj.icon, text}
          return arr.concat([newMetric])
        } else {
          return arr
        }
      }, [])
    }
  }
}

</script>

<style lang="scss">

.metrics-banner {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;

  &__metric {
    min-width: rem(120);
    flex: 1 0 auto;
    font-size: rem(21);
    line-height: rem(21);
  }

  &__metric + &__metric {
    margin-left: 6px;
  }

  &__icon {
    position: relative;
    top: rem(2);
    margin-right: rem(5);
    fill: color(yellow);
    width: rem(21);
    height: rem(21);
  }

  &__loading {
    animation: pulse 1.2s infinite
  }

  @keyframes pulse {
    0% {
      opacity: 1
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}

</style>



// WEBPACK FOOTER //
// MetricsBanner.vue?229a6080